export default {
    htmlTitle: 'Flylux Gestionale',
    company: 'Flylux Srl(@projectJson.js)',
    navVerticalCompany: 'Flylux Srl',
    loginHeading: 'Login | Gestionale Flylux',
    logoSquare: '/logo/logo_square.png',
    logoBanner: '/logo/logo_full.png',
    logoShadapps: '/logo/logo_shadapps.png',
};
